export var sendDataLayerAnalytics = function sendDataLayerAnalytics(data) {
  // @ts-expect-error - будет ошибка, потому что нет d.ts для global
  if (typeof window !== 'undefined' && window.dataLayer) {
    // @ts-expect-error - будет ошибка, потому что нет d.ts для global
    window.dataLayer.push(data);
  }
};